import request from '@utils/request-wordpress'
import configRequest from "@src/config/request-wordpress";

export const state = {
};

export const getters = {
};

export const mutations = {
};

export const actions = {
  // 取得會員資料
  fetchMember({ commit }) {
    return request
      .get(`/member`, {
        ...configRequest,
        name: 'fetchMember',
      })
  },
  // 更新會員資料
  storeMember({ commit }, submitData) {
    return request
      .post(`/member/update`, submitData,{
        ...configRequest,
        name: 'storeMember',
      })
  },
  // 取得會員專區資料
  fetchMembership({ commit }) {
    return request
      .get(`/member/membership`, {
        ...configRequest,
        name: 'fetchMembership',
      })
  },
  // 取得發票資訊
  fetchMemberInvoice({ commit }) {
    return request
      .get(`/member/invoice`, {
        ...configRequest,
        name: 'fetchMemberInvoice',
      })
  },
  // 更新發票資訊
  storeMemberInvoice({ commit }, submitData) {
    return request
      .post(`/member/invoice`, submitData,{
        ...configRequest,
        name: 'storeMemberInvoice',
      })
  },
  /**
   * 取得訂單列表
   * @param commit
   * @param status
   * @param limit
   * @param page
   * @returns {*}
   */
  fetchOrderList({ commit }, {
    status,
    page = 1,
    limit = 10,
  } = {}) {
    return request
      .post(`order/list`, {
        status,
        page,
        limit,
      }, {
        ...configRequest,
        name: 'fetchOrderList'
      })
  },
  /**
   * 取得單一訂單
   * @param commit
   * @param id
   * @returns {*}
   */
  fetchOrderItem({ commit }, { id }) {
    return request
      .get(`order/${id}`, {
        ...configRequest,
        name: 'fetchOrderItem'
      })
  },
  /**
   * 取消單一訂單
   * @param commit
   * @param id
   * @returns {*}
   */
  cancelOrderItem({ commit }, id) {
    return request
      .post(`order/cancel`, {
          id 
        }, {
        ...configRequest,
        name: 'cancelOrderItem'
      })
  },
  /**
   * 取得購物點數列表
   * @param commit
   * @param status
   * @param limit
   * @param page
   * @returns {*}
   */
  fetchPointList({ commit }, {
    status,
    limit = 10,
    page = 1,
  }) {
    return request
      .post(`point/list`, {
          status,
          limit,
          page,
        }, {
        ...configRequest,
        name: 'fetchPointList'
      })
  },
  /**
   * 取得優惠券列表
   * @param commit
   * @param status
   * @param limit
   * @param page
   * @returns {*}
   */
  fetchCouponList({ commit }, {
    status,
    limit = 10,
    page = 1,
  }) {
    return request
      .post(`coupon/list`, {
          status,
          limit,
          page,
        }, {
        ...configRequest,
        name: 'fetchCouponList'
      })
  },
  /**
   * 新增優惠券
   * @param commit
   * @param code
   * @returns {*}
   */
  addCoupon({ commit }, {
    code
  }) {
    return request
      .post(`coupon/add`, {
          code,
        }, {
        ...configRequest,
        name: 'addCoupon',
        showMessage: false,
      })
  },
  /**
   * 取得購物車內容
   * @param commit
   * @returns {*}
   */
  fetchCart({ commit }) {
    return request
      .get(`/cart/content`, {
        ...configRequest,
        name: 'fetchCart',
      })
  },
};
